import { render, staticRenderFns } from "./legal-user-info.vue?vue&type=template&id=583ce7f3&scoped=true"
import script from "./legal-user-info.vue?vue&type=script&lang=js"
export * from "./legal-user-info.vue?vue&type=script&lang=js"
import style0 from "./legal-user-info.vue?vue&type=style&index=0&id=583ce7f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583ce7f3",
  null
  
)

export default component.exports